import React, { Fragment } from 'react';
import {VisuallyHidden} from "@reach/visually-hidden";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = ({tooltip, iconObj, color = 'black'}) => (
  <Fragment>
    <VisuallyHidden>{tooltip}</VisuallyHidden>
    <FontAwesomeIcon icon={iconObj} title={tooltip} style={{color: color}} />
  </Fragment>
);

export default Icon;